import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import mr from "../Scripts"; // Script file from Stack template
import BlockUi from "react-block-ui";
import { Loader } from "react-loaders";
import { BackToTop } from "../Components/Common/BackToTop";
import { toggleBlockingStatus } from "../Store/Status/Actions";

class LayoutLogin extends Component {
    componentWillMount() {
        document.getElementsByTagName("body")[0].classList.add("login-page");
        this.props.toggleBlockingStatus(false);
    }

    render() {
        const { serverError, blockingStatus } = this.props;

        if (serverError) {
            console.error("Server Error: ", serverError);
            // document.querySelector("#server-error-msg").textContent = serverError;
            // $("#server-error-modal").modal("show");
        }

        return (
            <BlockUi tag="div" blocking={blockingStatus} loader={<Loader active type="cube-transition" color="#3097B9"/>}>
                <a id="start"></a>
                { this.props.children }
                <BackToTop/>
            </BlockUi>
        );
    }
}

function mapStateToProps(state) {
    return {
        blockingStatus: state.blockingStatus,
        serverError: state.serverError
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        toggleBlockingStatus: toggleBlockingStatus
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LayoutLogin));